module.exports = __webpack_public_path__ + "static/img/banner2.8557600.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner2.png
// module id = i4Cj
// module chunks = 1